import React from 'react';
import { ResponsivePie } from '@nivo/pie' 

export default function Pie2Graph({data}) {

  /*const data = [
    {
      "id": "Facebook",
      "label": "Facebook",
      "value": 520
    },
    {
      "id": "Instagram",
      "label": "Instagram",
      "value": 131
    },
    {
      "id": "Site",
      "label": "Site",
      "value": 45
    },
    {
      "id": "Google",
      "label": "Google",
      "value": 528
    },
    {
      "id": "Outros",
      "label": "Outros",
      "value": 445
    }
  ];*/

return(
    <ResponsivePie
        data={data}
        margin={{ top: 0, right: 10, bottom: 100, left: 10 }}
        startAngle={-180}
        colors={{ scheme: 'pastel1' }}
        borderColor={{ from: 'color', modifiers: [ [ 'opacity', '1.2' ] ] }}
        enableRadialLabels={false}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={16}
        radialLabelsLinkHorizontalLength={24}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#333333"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        defs={[
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                size: 4,
                padding: 1,
                stagger: true
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
            }
        ]}
        legends={[
            {
                anchor: 'top-left',
                direction: 'column',
                justify: false,
                translateX: 0,
                translateY: 130,
                itemsSpacing: 1,
                itemDirection: 'left-to-right',
                itemWidth: 200,
                itemHeight: 15,
                itemOpacity: 0.75,
                symbolSize: 9,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
)};